class GridSwatchs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    // Implementation of rendering logic will go here

    // Assuming swatch element has the class "product-item__swatches__count"
    const swatchElement = this.querySelector('.product-item__swatches__count');

    swatchElement.addEventListener('mouseover', () => {
      // Add the "selected-area" class to the grid-swatch container on mouseover
      this.classList.add('selected-area');
    });

    swatchElement.addEventListener('click', () => {
      // Add the "selected-area" class to the grid-swatch container on mouseover
      this.classList.add('selected-area');
      this.classList.add('disabled-area');
      setTimeout(()=>{
        this.classList.remove('disabled-area');
      },500)
    });

    this.addEventListener('mouseleave', () => {
      // Remove the "selected-area" class from the grid-swatch container on mouseout
      this.classList.remove('selected-area');
    });
  }
}

customElements.define('grid-swatch', GridSwatchs);



class InventoryTracker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    // Implementation of rendering logic will go here
    window.addEventListener('PRODUCT:VARIANT_CHANGE', (e)=>{
      this.classList.remove('low')
      this.classList.remove('unavailable')
      this.classList.remove('available')
      const variants = JSON.parse(this.dataset['inventory']);
      variants.forEach(variant=>{
        if(variant.id==e.detail.variant.id){
          if(variant.quantity==0){
            this.classList.add('unavailable')
          }
          else if(variant.quantity>parseInt(this.dataset['tracker'])){
            this.classList.add('available')
          }
          else if(variant.quantity<=parseInt(this.dataset['tracker'])){
            this.classList.add('low')
          }
        }
      })
    });
  }
}

customElements.define('inventory-tracker', InventoryTracker);

class LinkItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.addEventListener('click', () => {
      window.location.href=this.dataset['href']
    });
  }
}
customElements.define('link-item', LinkItem);
